import globalCofig from "@/setting/setting";
export const mixinHomePage = {
  data() {
    return {};
  },
  deactivated() {},
  methods: {
    //我要报名
    signUp(row) {
      if (this.checkFlag === "5") {
        this.$message({
          showClose: true,
          message: "该公告您已报过名了",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
        return false;
      }
      row.supCode = row.supCode ? row.supCode : "";
      row.supName = row.supName ? row.supName : "";
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          globalCofig.agentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_BID_URL
            )}/shop/participate?schemeId=${row.schemeId}&purchaseType=${
              row.purchaseType
            }&noticeStartTime=${
              row.noticeStartTime
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
              row.supCode
            }&a=${globalCofig.agentId}`
          ),
        "_blank"
      );
    },
    toProject(obj) {
      window.open(
        `${this.$addUrlPerFix(
          process.env.VUE_APP_BID_URL
        )}/bidFlowIndex?a=100121&schemeId=${obj.schemeId}&noticeStartTime=${
          obj.noticeStartTime
        }&noticeEndTime=${obj.noticeEndTime}&schemeName=${
          obj.schemeName
        }&schemeCode=${obj.schemeCode}&supCode=${obj.supCode}&purchaseType=${
          obj.purchaseType
        }&supplierFlag=0`
      );
    },
    toProjectLocation(obj) {
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BID_URL
      )}/bidFlowIndex?a=100121&schemeId=${obj.schemeId}&noticeStartTime=${
        obj.noticeStartTime
      }&noticeEndTime=${obj.noticeEndTime}&schemeName=${
        obj.schemeName
      }&schemeCode=${obj.schemeCode}&supCode=${obj.supCode}&purchaseType=${
        obj.purchaseType
      }&supplierFlag=0`;
    },
    //进入项目
    perform(row) {
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          globalCofig.agentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_BID_URL
            )}/bidFlowIndex?schemeId=${row.schemeId}&noticeStartTime=${
              row.noticeStartTime
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
              row.supCode
            }&supName=${encodeURIComponent(row.supName)}&a=${
              globalCofig.agentId
            }&purchaseType=${row.purchaseType}&supplierFlag=0`
          ),
        "_blank"
      );
    },
    //查看详情
    handleView(row, tabName) {
      console.log(window.location.origin);
      const { type, isJRZL, searchType } = this.$route.query;
      let url = this.$router.resolve({
        path:
          tabName == 7 || tabName == 8
            ? "viewNoticeSimpleDetail"
            : "/viewNoticeDetail",
        query: {
          type,
          isJRZL,
          searchType,
          schemeId: row.schemeId,
          schemeCode: row.schemeCode,
          schemeName: row.schemeName,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          schemeStatus: row.schemeStatus,
          checkFlag: row.checkFlag,
          supCode: row.supCode,
          supName: row.supName
        }
      });
      window.open(url.href, "_blank");
      // let params = [
      //   "schemeId=" + row.schemeId,
      //   "schemeCode=" + row.schemeCode,
      //   "schemeName=" + row.schemeName,
      //   "noticeId=" + row.noticeId,
      //   "opUnitName=" + row.opUnitName,
      //   "opUnitId=" + row.opUnitId,
      //   "purchaseType=" + row.purchaseType,
      //   "schemeStatus=" + row.schemeStatus,
      //   "checkFlag=" + row.checkFlag,
      //   "supCode=" + row.supCode,
      //   "supName=" + row.supName
      // ];
      // let url = "/viewNoticeDetail?" + params.join("&");
      // window.open(window.location.origin + url, "_blank");
    },
    //点击详情页面相关公告列表标题跳转
    handleNoticeTitle(row) {
      console.log(row.purStep);
      let type = 0;
      let isSimple = true;
      //18 -> 评标结果公示  13->流标  14->补遗  16，17 -> 中标通知
      switch (row.purStep) {
        case "13":
          type = "8";
          break;
        case "14":
          type = "7";
          break;
        case "16":
          type = "4";
          break;
        case "17":
          type = "4";
          break;
        case "18":
          type = "3";
          break;
        default:
          isSimple = false;
          break;
      }
      if (isSimple) {
        const { isJRZL, searchType } = this.$route.query;
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetail",
          query: {
            isJRZL,
            searchType,
            type: type,
            schemeId: row.schemeId,
            schemeName: row.schemeName,
            schemeCode: row.schemeCode,
            noticeId: row.noticeId,
            opUnitName: row.opUnitName,
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          }
        });
        window.open(url.href, "_blank");
      } else {
        this.handleView(
          Object.assign({}, row, {
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          })
        );
      }
    },
    //点击首页类目名称进入搜索页，并带过去条件
    handleClickCategory(item) {
      let url = this.$router.resolve({
        path: "/searchList",
        query: {
          categoryCode: item.categoryCode,
          categoryName: encodeURIComponent(item.categoryName)
        }
      });
      window.open(url.href, "_blank");
    },

    //详情页面 该单位还在采购 点击更多
    handleViewCommendUnit() {
      let url = this.$router.resolve({
        path: "/searchList"
      });
      window.open(url.href, "_blank");
    }

    //首页点击邀请公告跳转页面
    /*handleClickInviteNotice(item) {
      if (item.noticeStatus === "3" && item.checkFlag === "1") {
        this.signUp(item);
      } else if (item.checkFlag === "2" && item.schemeStatus === "3") {
        this.signUp(item);
      } else {
        this.perform(item);
      }
    }*/
  }
};
